import arrow from "../../images/arrow-7.svg"
import "./experience.css"

function ExpCard({ exp }) {
    const descComponents = exp.description.map((x, idx) => <p key={idx}>{x}</p>)

    return (
        <>
            <h3 className="experience-title">As a {exp.title}</h3>
            <h4 className="experience-subtitle">{exp.companyName} (From {exp.startDate} to {exp.endDate})</h4>
            <div className="experience-main">{descComponents}</div>
        </>
    )
}

export default function Experience() {

    const exps = [
        {
            companyName: "Uniqode (formerly Beaconstac)",
            title: "Software Development Engineer Intern ",
            startDate: "Janauary 2024",
            endDate: "Present",
            description: [
                "I contribute to the production code of The QR Code Generator website following Agile methodology, utilizing React and Python Django, with a focus on feature enhancements and bug fixes."
            ]
        },
        {
            companyName: "Reliance Industries Limited",
            title: "Backend Developer Intern",
            startDate: "June 2023",
            endDate: "July 2023",
            description: [
                "Designed and implemented an API using Node.js and Express.js to store server logs in a MongoDB database.",
            ]
        },
        {
            companyName: "Rapido Tasker",
            title: "Freelance App Developer",
            startDate: "July 2022",
            endDate: "October 2022",
            description: [
                "Developed Urban Company client-side and partner-side app clones for the company.",
                "Implemented essential features: Geo-location tracking with Realtime Firebase and Geofire, Google Maps integration for address, registration, Stripe payment gateway, and reward referrals using Firebase Dynamic links.",
                "Handled user authentication, service booking, in-app chat messaging, and app notifications.",
                "Utilized Flutter framework for hybrid app development and Firebase for the backend."
            ]
        }
    ]

    return (
        <div className="experience">
            <img className="experience-arrow" src={arrow} alt='arrow' />
            <h2 className="experience-header">My Work Experience</h2>
            <table>
                <tr>
                    <th><p>Company</p></th>
                    <th><p>Title</p></th>
                    <th><p>Period</p></th>
                </tr>
                {
                    exps.map(
                        (data) => (
                            <tr>
                                <td><p>{data.companyName}</p></td>
                                <td><p>{data.title}</p></td>
                                <td><p>{`${data.startDate} - ${data.endDate}`}</p></td>
                            </tr>
                        )
                    )
                }
            </table>
        </div>
    )
}